import {ChangeDetectionStrategy, Component, booleanAttribute, input, model, output} from '@angular/core';

@Component({
  selector: 'ms-collapse-panel',
  templateUrl: './collapse-panel.component.html',
  styleUrls: ['./collapse-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'theme()',
  },
})
export class CollapsePanelComponent {
  readonly theme = input<'compact' | ''>('');
  readonly collapsed = model(false);
  readonly stopPropagation = input(false, {transform: booleanAttribute});

  readonly toggle = output<boolean>();

  onToggle(event: MouseEvent): void {
    if (this.stopPropagation()) {
      event.stopPropagation();
    }

    this.collapsed.update(collapsed => !collapsed);
    this.toggle.emit(this.collapsed());
  }
}
